import { JobReportInfo } from '../../core-data-model';
import { JobApi } from './JobApi.connect';

const getMock: () => Partial<JobApi> = () => ({
    getJobReportInfo: async (
        jobId: string,
        languageLocal?: string,
        companyId?: string
    ) => new JobReportInfo()
});

export const jobApiServiceMock = {
    getMock,
    provider: (Service: typeof JobApi) => ({
        provide: Service,
        useValue: getMock()
    })
};
